const subscriptionPage = {
  en: {
    subscriptionPage: {
      planNames: { free: "Free", basic: "Basic", pro: "Professional", enterprise: "Enterprise" },
      features: {
        viewPublicResults: "View public results",
        basicMapAccess: "Basic map access",
        limitedApiCalls: "Limited API calls",
        fullMapAccess: "Full map access",
        downloadMaps: "Download maps",
        api500: "500 API calls/day",
        emailSupport: "Email support",
        liveReporting: "Live reporting access",
        unlimitedDownloads: "Unlimited downloads",
        api5000: "5000 API calls/day",
        prioritySupport: "Priority support",
        customBranding: "Custom branding",
        dedicatedInstance: "Dedicated instance",
        unlimitedApi: "Unlimited API calls",
        support247: "24/7 support",
        customIntegrations: "Custom integrations",
        whiteLabel: "White-label solution"
      },
      perMonth: "/month",
      contactUs: "Contact Us",
      userTypes: { observer: "Observer", client: "Client", party: "Party", admin: "Admin" },
      statuses: { active: "Active", inactive: "Inactive", cancelled: "Cancelled", expired: "Expired" },
      userType: "User Type",
      apiCallsToday: "API Calls Today",
      status: "Status",
      apiKeyDesc: "Use this key to access the EReMS Cameroon API",
      generating: "Generating...",
      popular: "Popular",
      freeSuccess: "Successfully subscribed to Free plan!",
      updateFailed: "Failed to update subscription",
      checkoutSessionFailed: "Failed to create checkout session",
      checkoutFailed: "Failed to initiate checkout",
      keyGenerated: "API key generated successfully!",
      keyGenerateFailed: "Failed to generate API key",
      keyCopied: "API key copied to clipboard"
    }
  },
  fr: {
    subscriptionPage: {
      planNames: { free: "Gratuit", basic: "Basique", pro: "Professionnel", enterprise: "Entreprise" },
      features: {
        viewPublicResults: "Consultation des résultats publics",
        basicMapAccess: "Accès de base à la carte",
        limitedApiCalls: "Appels API limités",
        fullMapAccess: "Accès complet à la carte",
        downloadMaps: "Téléchargement des cartes",
        api500: "500 appels API/jour",
        emailSupport: "Assistance par e-mail",
        liveReporting: "Accès aux rapports en direct",
        unlimitedDownloads: "Téléchargements illimités",
        api5000: "5000 appels API/jour",
        prioritySupport: "Assistance prioritaire",
        customBranding: "Image de marque personnalisée",
        dedicatedInstance: "Instance dédiée",
        unlimitedApi: "Appels API illimités",
        support247: "Assistance 24h/24 et 7j/7",
        customIntegrations: "Intégrations personnalisées",
        whiteLabel: "Solution en marque blanche"
      },
      perMonth: "/mois",
      contactUs: "Nous contacter",
      userTypes: { observer: "Observateur", client: "Client", party: "Parti", admin: "Administrateur" },
      statuses: { active: "Actif", inactive: "Inactif", cancelled: "Annulé", expired: "Expiré" },
      userType: "Type d'utilisateur",
      apiCallsToday: "Appels API aujourd'hui",
      status: "Statut",
      apiKeyDesc: "Utilisez cette clé pour accéder à l'API d'EReMS Cameroon",
      generating: "Génération...",
      popular: "Populaire",
      freeSuccess: "Abonnement au plan Gratuit effectué avec succès !",
      updateFailed: "Échec de la mise à jour de l'abonnement",
      checkoutSessionFailed: "Échec de la création de la session de paiement",
      checkoutFailed: "Échec de l'initiation du paiement",
      keyGenerated: "Clé API générée avec succès !",
      keyGenerateFailed: "Échec de la génération de la clé API",
      keyCopied: "Clé API copiée dans le presse-papiers"
    }
  }
};

export default subscriptionPage;
